module.exports = __webpack_public_path__ + "static/img/biomass-burner_64.e3233ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/biomass-burner_64.png
// module id = zgaJ
// module chunks = 0